import Vue from "vue";
export default Vue.extend({
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            validator: (v) => ["success", "error", ""].includes(v),
        },
        timeout: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        isOpen: true,
        colors: {
            success: "bg-green-10 border-green-300 text-green-500",
            error: "bg-red-10 border-red-300 text-red-500",
        },
    }),
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.isOpen = val;
                if (val && this.timeout) {
                    setTimeout(() => {
                        this.isOpen = false;
                    }, this.timeout);
                }
            },
        },
        isOpen: {
            handler(val) {
                this.$emit("input");
                if (!val) {
                    this.$emit("hide");
                }
                else {
                    this.$emit("show");
                }
            },
        },
    },
});
